import { render, staticRenderFns } from "./addPrice-popup.vue?vue&type=template&id=b0b40ac2&scoped=true&"
import script from "./addPrice-popup.vue?vue&type=script&lang=js&"
export * from "./addPrice-popup.vue?vue&type=script&lang=js&"
import style0 from "./addPrice-popup.vue?vue&type=style&index=0&id=b0b40ac2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b40ac2",
  null
  
)

export default component.exports